import {
  Applicant,
  ApplicantAddressType,
  ApplicationProps,
  JointholderRelationMaster,
} from '../redux-store/types/api-types';
import {
  applicantStatusMasters,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  BloodRelations,
  dateDematAccountDetails,
  DistributorTypesForUserManageMent,
  dlclIdFieldValidationDate,
  DLCLMasters,
  KBOLT_XALT_MASTER,
  REtypeMaster,
  SALT,
  SALT2,
  USER_ROLES,
  ReasonTinMaster,
  gamblingValidationDate,
} from './constant';
import { ToWords } from 'to-words';
import { numberRegex } from './regex';
import _ from 'lodash';
import { FundProps } from '../redux-store/types/funds';
import en from '../lang/en-us';
import { togglerType } from '../redux-store/types/mdms';
import {
  MenuItemListLink,
  NonIndividualMenuItemListLink,
} from '../components/investors/components';

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => ['firstapplicant', '1'].includes(applicant.applicant_type || ''))
      ?.name || 'N/A'
  );
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export const formatToIndianCurrency = (value: number | null): string => {
  const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'INR' };
  if (value) {
    return new Intl.NumberFormat('en-IN', options).format(value);
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0].concat('.', a[1].substr(0, 2));
  }
  return str;
}

export const formatCurrency = (value?: number | null): string => {
  const formats = ['K', 'L', 'Cr'];
  let amount: any = Number(value);
  formats.some((key, i) => {
    const size = Math.pow(10, i === 0 ? 3 : 3 - 1);
    if (size <= amount) {
      amount = toExactSubstr(`${amount / size}`);
      if (amount >= 100 && i < formats.length - 1) {
        i++;
      } else {
        // amount = (amount * decPlaces) / decPlaces;
        amount += ' ' + formats[i];
        return true;
      }
    } else {
      return true;
    }
  });
  return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    address1: '',
    address2: '',
    // address3: '',
    city: '',
    state: '',
    country: addressType === 'overseas' ? '' : 'INDIA',
    pincode: '',
    permanentAddressSameAsCorresponding: false,
    address_type: addressType,
    isActive: true,
    fetchedFromKRA: null,
  };
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null): boolean {
  return ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''].includes(
    relationValue || ''
  );
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null
): string => {
  return role === USER_ROLES.INVESTOR
    ? `/investment-details/${applicant1ReferenceId}/application-details`
    : role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
    ? `/application-details/${id}`
    : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};

export function currencyConversion(num?: string | number | null): string | null {
  if (!num) return '';
  const toWords = new ToWords();
  const words = toWords.convert(Number(num), { currency: true });
  return words;
}

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any) => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}
export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, city, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    city: city,
    pincode: pincode,
    state: state,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  const { nationality, status, ...addressProps } = updatedAddresses;
  return Object.keys(addressProps)
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: any): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.AMCAPPROVER,
    USER_ROLES.AMC_ADMIN,
  ].includes(role);
};

export const checkKraBasedOnStatus = (status: any): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication: Partial<ApplicationProps> | null,
  updatedApplication: Partial<ApplicationProps>
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  return application?.applicants.map((applicant) => applicant.status).includes('NRI');
};

export const checkForCorrespondenceAddress = (
  nationality: string | null | undefined,
  status: string | null | undefined
): boolean => {
  return (
    nationality?.toLowerCase() === 'indian' &&
    applicantStatusMasters[status as string] === applicantStatusMasters.Individual
  );
};

export const setUpFeeCalculations = (
  comitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(comitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount),
    feeGst: Number(GstForSetupFee),
    totalSetupFee: Number(setupFeeAmount + GstForSetupFee),
  };
};

export const checkAddressField = (data?: string) => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${
    address3 ? checkAddressField(address2) || '' : address2 || ''
  }${address3 || ''}`;
};

export const numToAlpMonth = (numMonth: any, month: any) => {
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};

export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

export function encodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null): boolean {
  return [
    'MOTHER',
    'FATHER',
    'DAUGHTER',
    'SON',
    'SPOUSE',
    'BROTHER',
    'SISTER',
    '',
    'Husband',
    'Wife',
    'Cousin',
    'Father-in-law',
    'Sister-in-law',
    'Brother-in-law',
    'Mother-in-law',
    'Grandson',
  ].includes(relationValue || '');
}

export function applicationDownloadStatusCheck(status: string): boolean {
  return [
    'sent_to_applicant1',
    'approved_by_applicant1',
    'approved_by_applicant2',
    'approved_by_applicant3',
    'approved_by_authorised_signatories',
    'approved_by_fundmanager',
    'signed',
  ].includes(status);
}

export function updatedCommitmentAmount(
  minCommitmentAmount: number,
  applicants: Partial<Applicant>[],
  data: JointholderRelationMaster
): number | void {
  if (applicants.length === 2) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele)
      ?.toString();
    const relation = BloodRelations.includes(
      ['Wife', 'Husband'].includes(applicantRelation) ? 'Spouse' : applicantRelation
    )
      ? applicantRelation
      : 'Others';
    const amount = data.singleJointHolder
      .map((jointHolder) => {
        if (jointHolder.jointHolder1RelationShip === relation) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
  if (applicants.length === 3) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele);
    const relation = applicantRelation.map((_relation) =>
      BloodRelations.includes(
        ['Wife', 'Husband'].includes(_relation || '') ? 'Spouse' : (_relation as string)
      )
        ? _relation
        : 'Others'
    );
    const amount = data.twoJointHolders
      .map((jointHolder) => {
        if (
          relation[applicants.length - 3] === jointHolder.jointHolder1RelationShip &&
          relation[applicants.length - 2] === jointHolder.jointHolder2RelationShip
        ) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
}

export const opsRmCheck = (loggedInUserId: string): boolean => {
  return ['607'].includes(loggedInUserId?.toString());
};

export const getdpIdField = (value: string): boolean => {
  return (
    DLCLMasters[value || ''] === DLCLMasters.cdsl || DLCLMasters[value || ''] === DLCLMasters.nsdl
  );
};

export const clearclIdField = (value: string): boolean => {
  return (
    DLCLMasters[(value as string) || ''] === DLCLMasters.none ||
    DLCLMasters[(value as string) || ''] === DLCLMasters.cdsl
  );
};

export const cleardpIdField = (value: string): boolean => {
  return DLCLMasters[(value as string) || ''] === DLCLMasters.none;
};

export const getclIdField = (value: string): boolean => {
  return DLCLMasters[value || ''] === DLCLMasters.nsdl;
};

export const isCDSL = (value: string): boolean => {
  return DLCLMasters[(value as string) || ''] === DLCLMasters.cdsl;
};

export const checkValidationBasedOnDate = (
  date: string | number | Date,
  validationStartDate: string
): boolean => {
  if (!date) return false;
  const dateForCompare = date ? new Date(date) : new Date();
  const dateForApplyValidations = new Date(validationStartDate);
  return dateForCompare.getTime() >= dateForApplyValidations.getTime();
};

export const getDPCLIDFieldVal = (fieldVal: { [key: string]: string }, createdAt: string) => {
  return Object.keys(fieldVal).filter((ele) => {
    if (checkValidationBasedOnDate(createdAt, dateDematAccountDetails)) {
      return ele !== 'none';
    }
    return ele;
  });
};

export const isIndividualDistributorType = (value: string): boolean =>
  value === DistributorTypesForUserManageMent.Individual;

export const getClassPlanOptionsOrDetails = (
  selectedFundId: string | number | null,
  fundsList: FundProps[]
) => {
  const selectedFund = fundsList?.find((f) => Number(f.id) === Number(selectedFundId)) as FundProps;
  return selectedFund?.plans?.map((plan) => ({ key: plan.id, value: plan.planDescription })) || [];
};
export const getSideNavComponent = (
  navOptions: string[],
  createdAt: string,
  toggler: togglerType
): string[] => {
  let _navOptions: string[] = navOptions;
  // _navOptions = !RiskProfileEnabled
  //   ? _navOptions.filter((e) => !['risk-profiles', 'Risk Profiles'].includes(e))
  //   : _navOptions;
  _navOptions = checkValidationBasedOnDate(
    createdAt,
    toggler?.dateFeatureToggles?.nomineeRemovalAndDeclarationValidationDate || ''
  )
    ? _navOptions.filter((e) => !['nominee-details', 'Nominee Details'].includes(e))
    : _navOptions;

  _navOptions = !checkValidationBasedOnDate(
    createdAt || '',
    toggler.dateFeatureToggles?.qibChecklistValidationDate
  )
    ? _navOptions.filter((e) => !['qib-CheckList', 'QIB CheckList'].includes(e))
    : _navOptions;
  return _navOptions;
};
export const dlclIdFieldMandatory = (): boolean => {
  return checkValidationBasedOnDate(new Date(), dlclIdFieldValidationDate);
};

/**
 * Replace with your file URL or API endpoint
 * @param fileUrl
 *
 * Desired file name
 * @param fileName
 */
export const handleDownload = async (fileUrl: string, fileName: string): Promise<void> => {
  try {
    const url = new URL(fileUrl, window.location.origin);

    const isSameOrigin = url.origin === window.location.origin;

    if (isSameOrigin) {
      // Same-origin: rename supported
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error('Unable to download file');
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(blobUrl);
    } else {
      // Cross-origin (e.g. S3): no fetch => no CORS issue
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.error('Download failed:', error);
    throw error;
  }
};

export const pepandAmlCheck = (applicants: Partial<Applicant>[]): boolean => {
  return applicants.length
    ? applicants.some(
        (applicant) =>
          ['I am PEP', 'I am Related to PEP'].includes(
            applicant.politicallyExposedPersonStatus || ''
          ) || !applicant.amlCheck
      )
    : false;
};

export const otherBrokerNamePresent = (nameOfBroker: string): boolean => {
  return nameOfBroker.toLowerCase() === 'others';
};

export const displaySendBack = (application: ApplicationProps): string => {
  return application.applicationSentBack ? '(Send Back)' : '';
};

export const AMCApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.AMCAPPROVER;

export const MakerOrAdmin = (role: USER_ROLES): boolean =>
  [USER_ROLES.AMC_ADMIN, USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(
    role
  );

export function checkIfApplicationIsNonIndividualPOA(application: ApplicationProps): boolean {
  if (application) {
    const { applicationType, hasPOA } = application;
    return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL && hasPOA;
  } else return false;
}
export const ifPushToXalt = (value: string): boolean => {
  return [KBOLT_XALT_MASTER.XALT, KBOLT_XALT_MASTER.KBOLT_XALT].includes(value);
};

export function getDocNumberForMultipleDocs(docArraylength: number): string | null {
  switch (docArraylength.toString()) {
    case '1':
      return 'first ';
    case '2':
      return 'second ';
    case '3':
      return 'third ';
    default:
      return '';
  }
}
export const getCurrentStep = (
  applicationType: string,
  current: string,
  isTopUp: boolean,
  isSaveLater: boolean,
  createdAt = '',
  toggler: togglerType = {} as togglerType
): number => {
  const navList =
    applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? getSideNavComponent(NonIndividualMenuItemListLink, createdAt, toggler)
      : getSideNavComponent(MenuItemListLink, createdAt, toggler);

  const normalizedCurrent = current.split('/').pop();
  const stepIndex = navList.findIndex((item) => item === normalizedCurrent);
  const currentStep = stepIndex + 1;

  return isSaveLater ? currentStep - 1 : currentStep;
};

export const navigateToNextStep = (
  currentPath: string,
  role: string,
  id: string,
  isSaveLater = false,
  applicant1ReferenceId: string,
  applicationType: string,
  isTopUp: boolean,
  createdAt = '',
  toggler: togglerType = {} as togglerType
): string => {
  const navList =
    applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? getSideNavComponent(NonIndividualMenuItemListLink, createdAt, toggler)
      : getSideNavComponent(MenuItemListLink, createdAt, toggler);
  const normalizedCurrent = currentPath.split('/').pop();
  const currentIndex = navList.findIndex((path) => path === normalizedCurrent);
  const nextIndex = currentIndex + 1;
  if (nextIndex < navList.length && !isSaveLater) {
    return navList[nextIndex];
  }
  // Below Logic is for last page navigation
  // Handle INVESTOR role
  if (role === USER_ROLES.INVESTOR) {
    return `/${
      isTopUp ? 'topup' : 'investment-details'
    }/${applicant1ReferenceId}/application-details`;
  }

  // Handle POA/AMC Approver role
  if (role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER) {
    return `/application-details/${id}`;
  }

  // Handle Save Later path
  if (isSaveLater) {
    return `/applications`;
  }

  // Handle based on application type
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
    ? `/non-individual-application-preview/${id}`
    : `/application-preview/${id}`;
};

export const getQuestionId = (questionId: string): string => {
  switch (questionId) {
    case 'Q6.1.7':
      return '1';
    case 'Q6.2.2':
      return '2';
    case 'Q6.2.6':
      return '3';
    default:
      return '4';
  }
};

export const ifTinVerificationApplicable = (id: string, createdAt: string): boolean => {
  if (checkValidationBasedOnDate(createdAt, gamblingValidationDate)) {
    return id === 'Q2.4';
  }
  const matchFound = [6, 9].some((item) => {
    const check = [
      `Q${item}.2.2`,
      `Q${item}.2.6`,
      `Q${item}.3.2`,
      `Q${item}.1.7`,
      `Q${item}.2.4`,
    ].includes(id);
    return check;
  });
  return matchFound;
};

export const tinDocumentCheck = (id: string, createdAt: string): boolean => {
  if (checkValidationBasedOnDate(createdAt, gamblingValidationDate)) {
    return ['Q2.4'].includes(id);
  }
  return ['Q6.2.4', 'Q9.2.4'].includes(id);
};

export function getValueByPath(obj: any, path: string) {
  const ids = path.split('Q')[1].split('.');
  const res = ids.reduce((prev, next, index) => {
    if (!prev) return undefined;

    const current = prev[Number(next) - 1];
    if (!current) return undefined;

    return index === ids.length - 1 ? current : current.sub_questions;
  }, obj);
  return res;
}

export const getIsServiceRequired = (applicant: any): string[] => {
  const isServicesRequired: string[] = [];
  if (applicant.isMoneyLending === 'yes') isServicesRequired?.push('isMoneyLending');

  if (applicant.isGamingOrGambling === 'yes') isServicesRequired?.push('isGamingOrGambling');

  if (applicant.isForeignExchange === 'yes') isServicesRequired?.push('isForeignExchange');

  if (applicant.isNoneOfThese === 'yes') isServicesRequired?.push('isNoneOfThese');
  return isServicesRequired;
};

export const getServicesUpdate = (isServicesRequired: string[]) => {
  return {
    isMoneyLending: isServicesRequired?.includes('isMoneyLending') ? 'yes' : 'no',
    isGamingOrGambling: isServicesRequired?.includes('isGamingOrGambling') ? 'yes' : 'no',
    isForeignExchange: isServicesRequired?.includes('isForeignExchange') ? 'yes' : 'no',
    isNoneOfThese: isServicesRequired?.includes('isNoneOfThese') ? 'yes' : 'no',
  };
};
export const OthersTINReason = (value: string): boolean => {
  return ReasonTinMaster[value || '']?.code === ReasonTinMaster.reason_c?.code;
};

export const minNetworthDate = (value: string): Date => {
  const date = new Date(value);
  date.setFullYear(date.getFullYear() - 1);
  return date;
};
export const shouldShowRBICategory = (rbiRegulatedEntity?: string) => {
  return rbiRegulatedEntity?.toLowerCase() === 'yes';
};

export const OthersOptionForRE = (value: string): boolean => {
  return REtypeMaster[value || ''] === REtypeMaster.others;
};
